import { ClearRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Divider,
	IconButton,
	InputLabel,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import axios from "axios";
import CustomTextField from "components/EboStoreV4/CommonComponents/CustomTextfield/CustomTextfield";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import {
	addOrEditModelAction,
	autoUpdateStoreBasicDetailsData,
	autoUpdatestoreMainFieldsData,
	billerDetailsTableColumns,
	getColDefaultValue,
	leaseDetails,
	storeBasicDetailsFields,
	storeMainFields,
	storesLinkedTables,
	storeTypeDetails,
} from "components/EboStoreV4/data";
import { constraintsOptions } from "data/globalData";
import { inputTypes } from "data/pimData";
import { agreementData } from "data/supplierPageData";
import { useState } from "react";

const AddOrEditModal = ({ modal, setModal, type, defaultData, handleUpdateDetails, selectedStore, setSelectedStore }) => {
	const defFields = (() => {
		let obj = {};
		storeBasicDetailsFields?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	})();
	const [formData, setFormData] = useState(type === addOrEditModelAction.UPDATE ? defaultData : defFields);

	const handleModalclose = () => {
		setModal(false);
	};

	const handleCallBackFun = () => {
		setSelectedStore({ ...selectedStore, eboStoreBasicDetails: formData });
		setFormData(defFields);
		setModal(false);
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		handleUpdateDetails(storesLinkedTables.store_basic_details.seqMethod, formData, handleCallBackFun);
	};
	return (
		<Dialog maxWidth="md" fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">{type === addOrEditModelAction.UPDATE ? "Update" : "Add"} Store Type Details</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Box display="flex" columnGap={"10px"} rowGap="10px" flexWrap="wrap" width="100%">
						{storeBasicDetailsFields?.map((row) => {
							return (
								<RenderInputField
									column={row}
									data={formData}
									setData={setFormData}
									width="24%"
									selectOptObjName={"option_data"}
									dependencyColData={autoUpdateStoreBasicDetailsData}
								/>
							);
						})}
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button variant="contained" sx={{ justifySelf: "center" }} type="submit">
						{type === addOrEditModelAction.UPDATE ? "Update" : "Add"}
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default AddOrEditModal;
